// Copyright (c) Microgreen Manager LLC. All rights reserved. Proprietary and confidential. Unauthorized copying is strictly prohibited.
import { type RendererObject, marked } from 'marked';
import * as React from 'react';
import { Root } from './Markdown';

interface Props {
  readonly source: string;
  readonly 'data-test'?: string;
}

// Polyfill Array.at() for older browsers
if (!Array.prototype.at) {
  Array.prototype.at = function (n) {
    let newN = Math.trunc(n) || 0;
    if (newN < 0) newN += this.length;
    if (newN < 0 || newN >= this.length) return undefined;
    return this[newN];
  };
}
export default function RenderMarkdown({ 'data-test': dataTest, source }: Props) {
  const renderer: RendererObject = {
    link({ href, text, title }): string {
      // If the link is for YouTube, then return a YouTube embed
      if (href.startsWith('https://www.youtube.com/watch?v=')) {
        const videoId = href.split('=')[1];
        const iframeStyles = 'position:absolute;top:0;left:0;width:100%;height:100%;';
        const wrapperStyles = 'position:relative;overflow:hidden;width:100%;padding-top:56.25%;';
        return `
          <div id="youtube-embed" style="${wrapperStyles}">
            <iframe
              style="${iframeStyles}"
              src="https://www.youtube.com/embed/${videoId}"
              title="${text}"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
          </div>
        `;
      }
      const isMicrogreenManagerLink = href.includes('microgreenmanager.com');
      return `<a href="${href}" ${title ? `title="${title}"` : ''} target="_blank" rel="noopener${isMicrogreenManagerLink ? '' : ' noreferrer'}">${text}</a>`;
    },
  };
  marked.use({ renderer });
  // biome-ignore lint/security/noDangerouslySetInnerHtml: <explanation>
  return <Root data-test={dataTest} dangerouslySetInnerHTML={{ __html: marked.parse(source, { async: false }) }} />;
}
